<template>
  <div class="w3-main main-container">

    <page-header />

    <div class="w3-container about-container">
      <h1 class="w3-xxxlarge"><b>{{ $t('News') }}</b></h1>

      <hr class="w3-round">

      <news-article
        v-for="(article, index) in news"
        :key="article._id"
        :article="article"
        :no-separator="index === news.length - 1"
      />
    </div>
  </div>
</template>

<i18n>
  {
    "de": {
      "News": "Nachrichten"
    },
    "en": {
      "News": "News"
    },
    "hu": {
      "News": "Híreink"
    }
  }
</i18n>

<script>
  import PageHeader from '@/components/PageHeader';
  import NewsArticle from '@/components/NewsArticle';
  import news from 'static/data/news.json';

  export default {
    name: 'news',
    data() {
      return {
        news,
      };
    },
    created() {
      document.title = 'Híreink | BeCreative';
    },
    mounted() {
      scrollTo(0, 0);
    },
    components: {
      PageHeader,
      NewsArticle,
      news,
    },
  };

</script>

<style scoped>
  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

  .about-container {
    margin-top: 75px;
    max-width: 1000px;
  }

</style>



// WEBPACK FOOTER //
// News.vue?65bcb33a